import { ref } from 'vue';

const account = ref(null);

export const useWallet = () => {
	const loading = ref(false);
	const pending = ref(false);
	const error = ref(null);

	const { ethereum } = window;

	const checkIfWalletIsInstalled = () => {
		if (!ethereum) {
			error.value = 'Metamask not installed';
		}

		return ethereum;
	};

	const connectWallet = async () => {
		error.value = null;
		loading.value = true;
		try {
			// Check Metamask Wallet install
			if (!checkIfWalletIsInstalled) return;

			// Get Metamask Wallet address
			const accounts = await ethereum.request({
				method: 'eth_requestAccounts',
			});
			if (accounts.length !== 0) {
				const data = accounts[0];
				account.value = data;
			}
		} catch (err) {
			if (err.message === 'Already processing eth_requestAccounts. Please wait.') {
				error.value = 'Your are not logged in to Metamask.';
			} else {
				error.value = err.message;
			}
		} finally {
			loading.value = false;
		}
	};

	const autoConnectWallet = async () => {
		error.value = null;
		pending.value = true;
		try {
			// Check Metamask Wallet install
			if (!checkIfWalletIsInstalled) return;

			// Retrieve connected Metamask Wallet address
			const accounts = await ethereum.request({ method: 'eth_accounts' });
			if (accounts.length !== 0) {
				const data = accounts[0];
				account.value = data;
			}
		} catch (err) {
			error.value = err.message;
		} finally {
			pending.value = false;
		}
	};

	return {
		loading,
		pending,
		error,
		account,

		connectWallet,
		autoConnectWallet,
	};
};

export default useWallet;
